import LinkButton from '../LinkButton/LinkButton';
import FALabel from '../shared/FALabel';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BillingCategoryType } from '../../propTypes';
import { billingCategoryGroups, modals } from '../../ducks';
import { connect } from 'react-redux';

const BillingCategoryRevenue = (props) => {
  const {
    category,
    showHistory,
    updateCategory
  } = props;

  const [status, setStatus] = useState(null);

  const MONTHS = [
    [1, 'January'],
    [2, 'February'],
    [3, 'March'],
    [4, 'April'],
    [5, 'May'],
    [6, 'June'],
    [7, 'July'],
    [8, 'August'],
    [9, 'September'],
    [10, 'October'],
    [11, 'November'],
    [12, 'December']
  ];

  const onSelectField = (field, value) => {
    updateCategory({
      ...category,
      [field]: value
    })
      .then(() => {
        setStatus({
          type: 'success',
          message: `Field "${field}" updated successfully!`
        });
      })
      .catch(({errors = []}) => {
        setStatus({
          type: 'error',
          message: `Sorry, something went wrong: ${errors.join(". ")}`
        });
      });
  };

  const viewHistory = () => {
    showHistory(category.id);
  };

  return (
    <div className='details-group-actions card bg-light'>
      {status && (
        <div className={`alert alert-${status.type === 'error' ? 'danger' : 'info'}`}>
          {status.message}
        </div>
      )}
      <div className={'category-group-options'}>
        <div
          className={'category-group-option rev-rec-start-month'}
        >
          <label>Revenue Recognition Start Month:</label>&nbsp;
          <select
            onChange={(e) => onSelectField('revenue_recognition_start_month', e.target.value)}
            value={category.revenue_recognition_start_month}
          >
            {MONTHS.map(([value, name]) =>
              <option key={value} value={value}>{name}</option>
            )}
          </select>
        </div>

        <div
          className={'category-group-option rev-rec-end-month'}
        >
          <label>Revenue Recognition End Month:</label>&nbsp;
          <select
            onChange={(e) => onSelectField('revenue_recognition_end_month', e.target.value)}
            value={category.revenue_recognition_end_month}
          >
            {MONTHS.map(([value, name]) =>
              <option key={value} value={value}>{name}</option>
            )}
          </select>
        </div>

        <div
          className={'category-group-option rev-rec-strategy'}
        >
          <label>Revenue Recognition Allocation Rule:</label>&nbsp;
          <select
            onChange={(e) => onSelectField('revenue_recognition_strategy', e.target.value)}
            value={category.revenue_recognition_strategy}
          >
            <option value={''}></option>
            <option value={'at_once'}>At Once</option>
            <option value={'equal_spread'}>Equal Spread</option>
            <option value={'remaining_spread'}>Remaining Spread</option>
            <option value={'spread_with_catchup'}>Spread With Catchup</option>
          </select>
        </div>
      </div>

      <LinkButton
        onClick={viewHistory}
        content={<FALabel label='View Edit History' icon='history'/>}
      />

    </div>
  );
};

BillingCategoryRevenue.propTypes = {
  updateCategory: PropTypes.func.isRequired,
  showHistory: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  updateCategory: (category) => (
    dispatch(billingCategoryGroups.actions.update(category))
      .then(() => dispatch(billingCategoryGroups.actions.markDirty('_active')))
  ),
  showHistory: (id) => (
    dispatch(modals.actions.show('AuditViewer', { id, resource: 'billing_categories' }))
  ),
});

export default connect(null, mapDispatchToProps)(BillingCategoryRevenue);
